import { render, staticRenderFns } from "./announcementsList.vue?vue&type=template&id=2de223f7&scoped=true"
import script from "./announcementsList.vue?vue&type=script&lang=js"
export * from "./announcementsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de223f7",
  null
  
)

export default component.exports